<template>
  <router-link
    v-if="!useBack && to"
    :to="to"
    class="inline-flex items-center justify-center gap-2 border border-stroke p-2 text-slate-700 transition hover:bg-slate-50"
    :class="{ 'px-3 py-2': showLabel }"
    :aria-label="label">
    <svg class="h-5 w-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
    </svg>
    <span v-if="showLabel" class="text-sm font-medium">{{ label }}</span>
  </router-link>
  <button
    v-else
    type="button"
    class="inline-flex items-center justify-center gap-2 border border-stroke p-2 text-slate-700 transition hover:bg-slate-50"
    :class="{ 'px-3 py-2': showLabel }"
    :aria-label="label"
    @click="router.back()">
    <svg class="h-5 w-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
    </svg>
    <span v-if="showLabel" class="text-sm font-medium">{{ label }}</span>
  </button>
</template>

<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'
import { useRouter } from 'vue-router'

const router = useRouter()

withDefaults(
  defineProps<{
    to?: RouteLocationRaw
    label?: string
    showLabel?: boolean
    useBack?: boolean
  }>(),
  {
    label: 'Voltar',
    showLabel: true,
    useBack: false,
  },
)
</script>
